import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { colors, layout } from 'Constants';
import { capital } from 'case';

import {
  Container,
  Header,
  Icon,
  Anchor,
  Button,
  Footnote
} from 'Components/core';
import Table from 'Components/Table/TableAlt';

// State
import { ApiStore, Subscribe } from 'Store';

import InfoBox from 'Components/InfoBox';
import ReadyToEnroll from 'Views/benefits/components/ReadyToEnroll';

// Images

import CODES from 'Root/libs/analytics/CodeDef';
import Api from 'Root/libs/analytics/Api';
import { replaceAnchor } from 'Root/libs/anchor';
import {
  HeaderV2,
  SubHeader,
  TitleHeader,
  TitleHeader2
} from 'Components/core/Header';
import PaddedContainer from 'Components/core/PaddedContainer';

import Arrrow from './images/arrow.svg';

export default props => {
  const [headers, setHeaders] = useState([]);
  const [rows, setRows] = useState([]);

  const updateTable = () => {
    const state = ApiStore.get();
    if (typeof state.vision?.visionPlanChart !== 'object') return;

    const chartData = { ...state.vision.visionPlanChart };

    setHeaders(['', chartData['headerVision']]);
    delete chartData['headerVision'];

    const values = Object.values(chartData);
    const keys = Object.keys(chartData);

    console.log(keys);
    console.log(values);
    const labelMap = {
      eyeExams: 'Routine eye exam',
      eyeglassFrames: 'Eyeglass frames',
      eyeglassLenses: 'Eyeglass lenses ',
      disposableContacts: 'Disposable contacts',
      nondisposableContacts: 'Non-disposable contacts'
    };

    setRows([...values.map((val, i) => [labelMap[keys[i]], val])]);
  };

  ApiStore.subscribe(updateTable);

  useEffect(() => {
    Api.recordAcitity(CODES.MENU_VISION_BENIFITS);
    updateTable();
  }, []);

  return (
    <Subscribe to={[ApiStore]}>
      {state => (
        <Container column maxWidth style={{ margin: 'auto' }}>
          <HeaderV2 title={'Helpful documents'} text={<></>}></HeaderV2>

          <PaddedContainer style={{ marginTop: 40 }} column>
            {state.oeMaterials?.oeBrochure?.oeBrochureURL &&
              (state?.oeMaterials?.oeBrochure?.oeBrochureURL + '').length >
                0 && (
                <EnrollmentDiv>
                  <div>Open Enrollment Booklet</div>
                  <div>
                    {' '}
                    <Anchor
                      code={CODES.MED_BFT_EN_BOOK}
                      to={state.oeMaterials?.oeBrochure?.oeBrochureURL}
                      style={{ alignSelf: 'center' }}
                    >
                      View or download{' '}
                      <img style={{ height: 14, width: 9 }} src={Arrrow} />
                    </Anchor>
                  </div>
                </EnrollmentDiv>
              )}
          </PaddedContainer>
        </Container>
      )}
    </Subscribe>
  );
};

const EnrollmentDiv = styled.div`
  display: flex;
  align-self: center;
  flex-direction: column;

  width: 552px;
  height: 133px;
  border-radius: 8px;
  background: #1355e9;

  justify-content: center;
  align-items: center;


  @media screen and (max-width: ${layout.breakpoints.mobile}) {
        width:100%;
  }


  > div {
    font-family: 'Elevance Sans semibold';
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    text-align: left;
    color: #fff;

    > a {
      font-family: 'Elevance Sans semibold';
      font-weight: 600;
      font-size: 18px;
      line-height: 26px;
      text-align: left;
      color: #fff;
    }
  }
`;
